var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "korpay",
    attrs: {
      "id": "korpay"
    }
  }, [_c('iframe', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }],
    ref: "iframe",
    staticClass: "screen",
    attrs: {
      "width": "100%",
      "height": "100%",
      "marginwidth": "0",
      "marginheight": "0",
      "frameborder": "no",
      "scrolling": "no"
    }
  })]);
}
var staticRenderFns = []

export { render, staticRenderFns }